// Global CSS first, so every feature stylesheet comes after the tokens and the reset. The font
// faces are linked in index.html (/fonts/fonts-v1.css), not imported here.
import '@dcs/ui/tokens.css';
import '@dcs/ui/base.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter } from 'react-router';
import { App } from './app';
import './env';
import { routes } from './routes';
import { getThemeStore } from './shared/theme/store';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

// theme-init.js already set data-theme before the first paint; the store takes over from here and
// keeps <meta name="theme-color"> in sync with the theme and the system scheme.
getThemeStore();

createRoot(root).render(
  <StrictMode>
    <App router={createBrowserRouter(routes)} />
  </StrictMode>,
);
